// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_online-task-inspection_thanks_thanks_module_ts":"fb05fa54ecf2a90c7fa8","src_app_error_forbidden_forbidden_module_ts":"d2ab5ceff19503bdaae2","src_app_error_not-found_not-found_module_ts":"a60c0d2333cb6ae10df3"}[chunkId] + ".js";
};